/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Chip } from "@mui/material"
import { IndividualState } from "./common"

type Props = {
  status: IndividualState,
  size?: any
}

export const IndividualStatusIcon = (props: Props) => {
  const { status, size = "medium" } = props
  const statusParams = (status: IndividualState): { label: string, color: any } => {
    switch (status) {
      case "registed":
        return { label: "搬入中", color: "default" }
      case "arrived":
        return { label: "搬入済", color: "warning" }
      case "accepted":
        return { label: "受入可", color: "success" }
      case "rejected":
        return { label: "受入不可", color: "default" }
      case "dismantled":
        return { label: "解体済", color: "info" }
      case "processed":
        return { label: "加工済", color: "primary" }
      default:
        return { label: "不明", color: "default" }
    }
  }
  const params = statusParams(status)
  return (
    <Box display="contents" justifyContent="center">
      <Chip label={params.label} color={params.color} size={size} />
    </Box>
  );
};
